(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var $ = jQuery;

(function($) {
	"use strict";


	$(document).ready(function() {

        $('#print-include-images').on('click', function () {
            $('#print-options').modal('hide');
            javascript:window.print();
        });

        $('#print-exclude-images').on('click', function () {
            $('body').addClass('print-no-images');
            $('#print-options').modal('hide');
            javascript:window.print();
            $('body').removeClass('print-no-images');
        });


        /**
         * Toggle off canvas navigation
         */
        $('[data-toggle="offcanvas-bottom"]').on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            offcanvas(target, 'bottom');

            // Fix scrolling issues on iOS
            var showMenu = $(target).hasClass('active');
            if(showMenu) {
                disableBodyScroll();
            } else {
                enableBodyScroll();
            }

        });

        function offcanvas(target, dir) {

            $(target).toggleClass('active');
            $('body').toggleClass('offcanvas-active-' + dir);

            /**
             * Add class to body to indicate that offcanvas is animating in or out.
             */
            $('body').addClass('offcanvas-animating-' + dir);
            $(target).on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
                $('body').removeClass('offcanvas-animating-' + dir);
            });

        }

        /**
         * Toggle for search mobile view
         */
        $('[data-toggle="search"]').on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            $(target).toggleClass('active');
            $('body').toggleClass('search-active');
            $('#search-input').focus();
        });

		var search_is_showing = false;
        var search_trigger = document.getElementById('search-trigger');
		$('#search-trigger').click(function (e) {
			if (!search_is_showing) {
                search_trigger.setAttribute('aria-expanded', 'true');
                $('#search-hidden-wrapper input').removeClass('hidden').focus();
				search_is_showing = true;

			} else {
                search_trigger.setAttribute('aria-expanded', 'false');
				$('#search-hidden-wrapper input').addClass('hidden');
				search_is_showing = false;
			}

		});



        $('.post-filter .dropdown-menu li a').click(function(){
            var selValue = $(this).data('value');
            var selText = $(this).text();

            if( selValue === 'false' ){
                $(this).parents('.btn-group').find('.category').val('');
            }else{
                $(this).parents('.btn-group').find('.category').val(selValue);
                $(this).parents('.btn-group').find('.dropdown-toggle').html(selText+' <span class="caret"></span>');
            }


        });

        $(document).ready(function(){
            $('.mega-menu-trigger').click(function(){
                $(this).find('.mega-menu-trigger__icon').toggleClass('open');
            });
        });


        $('.collapse').on('hide.bs.collapse', function () {
            $(this).closest('.card').find('.card-header__toggle').removeClass('shown');
            $(this).closest('.card').find('.card-header__toggle').addClass('closed');
            //alert('hide');

        });

        $('.collapse').on('show.bs.collapse', function () {
            $(this).closest('.card').find('.card-header__toggle').removeClass('closed');
            $(this).closest('.card').find('.card-header__toggle').addClass('shown');
            //alert('show');

        });






        $('.top-search input').on('focus', function () {
            $(this).closest('.input-group').find('.btn').show();

            $(this).closest('.input-group').stop().animate({
                width:'80%'
            },600);

        });


        $('#collapse-search').on('hidden.bs.collapse', function () {

            $('.top-search input').closest('.input-group').stop().animate({
                width:'40%'
            },600);

            $('.top-search input').closest('.input-group').find('.btn').hide();

        });


        $('#searcher').on('click', function (e) {

            var searchfield = $(this).closest('.navbar-actions').find('input');

            if ($(this).hasClass('open')) {

                $(this).removeClass('open');
                $(this).addClass('closed');

                searchfield.stop().animate({
                    width:'0'
                },100, function() {
                    searchfield.hide();
                });


            } else {
                $(this).addClass('open');
                $(this).removeClass('closed');
                searchfield.show();

                searchfield.stop().animate({
                    //display: 'block',
                    width:'100%'
                },100, function () {
                    searchfield.focus();
                });

            }

            return false;
/*

             setTimeout(function(){
             $(this).closest('.input-group').find('.btn').hide();

             }, 1000);

             if(e.relatedTarget && e.relatedTarget.type === 'submit'){
             alert('asdfa');
             return false;
             }
*/
             });


/*
        $('.top-search input').on('blur', function (e) {

            $(this).closest('.input-group').stop().animate({
                width:'40%'
            },200, function() {
                $(this).closest('.input-group').find('.btn').hide();
            });

            /*
            setTimeout(function(){
                $(this).closest('.input-group').find('.btn').hide();

            }, 1000);

            if(e.relatedTarget && e.relatedTarget.type === 'submit'){
                alert('asdfa');
                return false;
            }

        });

*/
/*

        $('.site-header').data('size','big');


        $(window).scroll(function(){
            if($(document).scrollTop() > 0)
            {
                if($('.site-header').data('size') == 'big')
                {
                    $('.site-header').data('size','small');
                    $('.site-header').stop().animate({
                        height:'40px'
                    },600);
                }
            }
            else
            {
                if($('.site-header').data('size') == 'small')
                {
                    $('.site-header').data('size','big');
                    $('.site-header').stop().animate({
                        height:'100px'
                    },600);
                }
            }
        });

*/


        var scroll_start = 0;
        var icon_changed = false;


            $(document).scroll(function() {
                scroll_start = $(this).scrollTop();

                if(scroll_start > 20) {
                    $('.site-header').removeClass('shrink');
                    $('.site-header').addClass('shrinked');
                } else if( scroll_start <= 20) {
                    $('.site-header').removeClass('shrinked');
                    $('.site-header').addClass('shrink');
                }

                if ( $('.site-header').hasClass('frontpage') ) {
                    if (scroll_start > 350) {
                        $('.site-header').find('input').show();
                        $('.site-header').find('.btn-search').show();
                    } else if (scroll_start <= 350) {
                        $('.site-header').find('input').hide();
                        $('.site-header').find('.btn-search').hide();
                    }
                }
            });

        /* Page feedback */
        $('#show-page-feedback-button').on('click', function() {
            $('.page-feedback-form-wrapper').css('border', '1px solid rgba(30, 30, 30, 0.1)' );
            $('.gform_wrapper').slideDown();
            $(this).attr('disabled', 'disabled');
        });


        /* Page feedback */
        if( $('.gform_confirmation_message').length ) {
            $('#show-page-feedback-button').hide();
        }


        /* Page tracker for search filter */
        if (typeof(Storage) !== "undefined") {

            if (typeof localStorage.visitedPagesStorage === 'undefined') {
                localStorage.visitedPagesStorage = "[]";
            }

            var pageId = $('meta[name="pageid"]').attr("content");
            pageId = parseInt(pageId);

            var visitedPages = JSON.parse(localStorage.visitedPagesStorage);
            var isPageIdSet = pageId !== null && !isNaN(pageId);

            if (isPageIdSet && visitedPages.indexOf(pageId) === -1) {

                visitedPages.push(pageId);
                localStorage.visitedPagesStorage = JSON.stringify(visitedPages);
            }

        }
        else {
            console.log("This browser does not support local storage, search filter on visited pages will no work");
        }



	});

})(jQuery);
(function($) {
	"use strict";

    var social = {};

    /*
    * On init.
    */
    social.init = function(){


        // Load our posts (All)
        social.loadPosts( -1 );
    }

    /**
     *  Click inside filter.
     */
    $('#socialmedia').on('click','.filter .btn', function(){
        var terms = false;

        // Set/unset selected class.
        $(this).toggleClass( 'selected' );

        // If all is selected, unselected all other.
        if( $(this).data('term-id') == '-1' ){
            $( '#socialmedia .btn.selected').removeClass('selected');
            $( '#socialmedia .btn.all').addClass('selected');
        }
        // Remove selected class from All when another filter is selected.
        else if( $(this).data('term-id') != '-1' ){
            $( '#socialmedia .btn.all').removeClass('selected');
        }
        // If no filter is selected set all as selected.
        if( ( $( '#socialmedia .btn.selected') ).length == 0 ) {
            $( '#socialmedia .btn.all').addClass( 'selected' );
        }

        // Get all selected terms.
        $.each( $('#socialmedia .filter .selected') , function( index, value ) {
            if( ! terms ){
                terms = $(this).data('term-id');
            }
            else {
                terms = terms + ',' + $(this).data('term-id');
            }
        });


         social.loadPosts( terms );

         return false;
    });



    /**
     *    Loads our posts.
     */
    social.loadPosts = function( terms ){
        // Add a loader.
        social.addLoader( $('#socialmedia .posts') );

        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            dataType: 'html',
            cache: false,
            data: {
                action: 'get_socialmedia_posts',
                nonce: ajax_object.ajax_nonce,
                terms: terms,
            },
            success: function( result ) {
                $("#socialmedia .posts").html( result );
            },
            error: function(result){
                $("#socialmedia .posts").html( '<p>Ett fel uppstod när formuläret skulle laddas!</p>' );
            }
        });

    }

    /**
     *    Adds a looader.
     */
    social.addLoader = function( element ){
        $( element ).html('<div class="card" style="border:0;"></div><div class="sk-circle black"><div class="sk-circle1 sk-child"></div><div class="sk-circle2 sk-child"></div><div class="sk-circle3 sk-child"></div><div class="sk-circle4 sk-child"></div><div class="sk-circle5 sk-child"></div><div class="sk-circle6 sk-child"></div><div class="sk-circle7 sk-child"></div><div class="sk-circle8 sk-child"></div><div class="sk-circle9 sk-child"></div><div class="sk-circle10 sk-child"></div><div class="sk-circle11 sk-child"></div><div class="sk-circle12 sk-child"></div></div>');
    }

	$(document).ready(function() {
        // Init functions.
        social.init();
    });


})( jQuery );

$(function () {
    $(".show-children").click(function (e) {
        var submenuID = e.currentTarget.dataset.id;

        var $parent = $(this).parent();
        // Reset expand arrow icon
        $parent.removeClass("expanded");

        // Collapse other submenus when opening new one
        if ($("." + submenuID).css("display") === "none") {
            $(".submenu-dropdown").css({
                "display": "none"
            });
            $parent.addClass("expanded");
            $(this).attr("aria-expanded", "true");
            $("." + submenuID).toggle("fast");
        } else {
            $("." + submenuID).toggle("fast");
            $(this).attr("aria-expanded", "false");
        }
    });

    // Close menu when clicking outside
    $(document).click(function (e) {
        var $target = $(e.target);
        if (!$target.closest(".show-children").length && !$target.closest(".submenu-dropdown").length) {
            $(".submenu-dropdown").hide("fast");
            $(".show-children").attr("aria-expanded", "false");
            $(".expanded").removeClass("expanded");
        }
    });

    $(".submenu-dropdown li:last-child a").on("keydown", function (e) {
        if (e.keyCode === 9) { // Tab key
            $(".submenu-dropdown").hide("fast");
            $(".show-children").attr("aria-expanded", "false");
            $(".expanded").removeClass("expanded");
        }
    });
});
$(document).ready(function () {
    // Function to close the mobile menu
    function closeMobileMenu() {
        $('.mobile-menu-icon').removeClass('expanded');
        $('.mobile-menu-icon').attr('aria-expanded', 'false');
        $('.mobile-menu-content').slideUp('fast');
        $('body').removeClass('menu-open');

        // Do not set focus if the menu is not open
        if ($('.mobile-menu-content').is(':visible')) {
            $('.mobile-menu-icon').focus();
        }
    }

    // Toggle mobile menu when icon is clicked
    $('.mobile-menu-icon').click(function (event) {
        var isExpanded = $('.mobile-menu-icon').attr('aria-expanded') === 'true';
        $('.mobile-menu-icon').toggleClass('expanded');
        $('.mobile-menu-icon').attr('aria-expanded', !isExpanded);
        $('.mobile-menu-content').slideToggle('fast');
        $('body').toggleClass('menu-open', !isExpanded);

        event.stopPropagation();
    });

    // Toggle search mobile content
    $('.search-mobile-icon').click(function (event) {
        $('.search-mobile-content').slideToggle('fast');
        var expanded = $('.search-mobile-icon').attr('aria-expanded') === 'false';
        $('.search-mobile-icon').attr('aria-expanded', expanded);
        if (expanded) {
            setTimeout(function () {
                $('.search-mobile-content input').focus();
            }, 300);
        }

        event.stopPropagation();
    });

    // Close mobile menu when clicking outside of it
    $(document).click(function (event) {
        if (!$(event.target).closest('.mobile-menu-content').length && !$(event.target).hasClass('mobile-menu-icon') && !$(event.target).closest('.mobile-menu-icon').length) {
            closeMobileMenu();
        }
    });

    // Handle tab key press to loop focus within the mobile menu
    $('.mobile-menu-content li:last-child').keydown(function (e) {
        if (e.which === 9 && !e.shiftKey) { // Tab key pressed
            e.preventDefault();
            $('.mobile-menu-content li:first-child a').focus(); // Set focus to the first item
        }
    });

    // Close mobile menu when Escape key is pressed
    $(document).keydown(function (e) {
        if (e.which === 27) { // Escape key pressed
            closeMobileMenu();
        }
    });
});

},{}]},{},[1])